<template>
  <div>
    <div class="row">
      <div class="col">
        <h5 class="title">Newsletter</h5>
      </div>
      <div class="col-md-auto text-right" v-if="role > 1">
        <p-button type="success" @click="newBuschtrommel()" class="mt-0" v-if="!editMode"><i
            class="bi bi-file-earmark-plus"></i> Neuer Newsletter</p-button>
        <p-button type="default" @click="editMode = false;" class="mt-0" v-if="editMode"><i class="bi bi-x-square"></i>
          Schließen</p-button>
      </div>
    </div>
    <div ref="editSection" class="row pt-3" v-if="editMode == true">
      <div class="col">
        <div class="card mt-2 pl-3 pr-3">
          <div class="card-header">
            <div class="row">
              <div class="col-sm-9">
                <h6 class="card-title">Newsletter erstellen/bearbeiten</h6>
              </div>
            </div>
          </div>
          <div class="card-body row">
            <div class="col">
              <mc-wysiwyg v-model="editText" :hide="editorHiddenElements"></mc-wysiwyg>
              <input ref="imageInput" type="file" accept="image/*" class="d-none" @change="insertImage">
              <input ref="wordInput" type="file" accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document" class="d-none" @change="importWordDocument">
              <p-button type="default" class="mt-2 mr-2" @click="selectImage">
                <i class="bi bi-image"></i> Bild einfügen
              </p-button>
              <p-button type="default" class="mt-2" @click="selectWordDocument">
                <i class="bi bi-file-earmark-word"></i> Word importieren
              </p-button>
            </div>
          </div>
          <div class="row pr-3 mb-2">
            <div class="col text-right">
              <el-checkbox v-model="sendMail" label="Per E-Mail an alle Mitarbeiter senden." border
                class="mr-3"></el-checkbox>
              <p-button type="default" @click="saveDraft()" class="mt-2 mr-3"><i class="bi bi-file-earmark-plus"></i>
                Entwurf speichern</p-button>
              <p-button type="success" @click="publish()" class="mt-2"><i class="bi bi-send"></i>
                Veröffentlichen</p-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row pt-3">
      <div class="col">
        <collapse>
          <div class="card mt-2 pl-3 pr-3" v-for="item in buschtrommel" :key="item.key">
            <collapse-item :title="item.title">
              <div class="row">
                <div class="col buschtrommel-content" v-html="item.text"></div>
              </div>
              <div class="row pt-3" v-if="item.status == 'Draft'">
                <div class="col text-right">
                  <p-button type="default" @click="edit(item.key, item.text)"><i class="bi bi-pencil-square"></i>
                    Bearbeiten</p-button>
                </div>
              </div>
            </collapse-item>
          </div>
        </collapse>
      </div>
    </div>
</div>
</template>
<script>
import Vue from "vue";
import { db, fc, storage } from "../../../../firebaseDb";
import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import { Table, TableColumn, Input, Loading, Popover, Checkbox, MessageBox } from "element-ui";
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
import Collapse from '../../../UIComponents/Collapse/Collapse.vue';
import CollapseItem from '../../../UIComponents/Collapse/CollapseItem.vue';
import { McWysiwyg } from '@mycure/vue-wysiwyg';
import { httpsCallable } from "firebase/functions";
import SelectLocation from '/src/components/KET/Views/Components/KETSelectLocation.vue'
import mammoth from 'mammoth/mammoth.browser';

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Checkbox);
Vue.use(Loading);

export default {
  components: {
    Collapse,
    CollapseItem,
    [Input.name]: Input,
    McWysiwyg,
    MessageBox,
    SelectLocation,
  },

  data() {
    return {
      buschtrommel: [],
      loading: false,
      editText: null,
      editId: null,
      editMode: false,
      sendMail: true,
      unsaved: false,
      editorHiddenElements: {
        heading: true,
        strikethrough: true,
      },
      location: store.getters.userlocation,
      role: store.getters.userrole,
    };
  },
  created() {
    this.loadData()
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.loadData();
      }
    );
  },
  beforeRouteLeave(to, from, next) {
    if (this.unsaved) {
      MessageBox.confirm(
        "Es gibt nicht gespeicherte Änderungen. Alle Änderungen gehen verloren. Seite wirklich verlassen?",
        "Warnung",
        {
          confirmButtonText: "Verlassen",
          cancelButtonText: "Abbrechen",
          type: "warning",
          callback: (action) => {
            if (action == "confirm") {
              next()
            } else {
              next(false)
            }
          },
        }
      );
    } else {
      next()
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventNav);
    this.detachPasteHandler();
  },
  watch: {
    editMode(val) {
      if (val) {
        this.$nextTick(() => this.attachPasteHandler());
      } else {
        this.detachPasteHandler();
      }
    },
  },
  methods: {
    attachPasteHandler() {
      const el = document.getElementById('editor');
      if (!el || el.__ketPasteAttached) return;
      el.addEventListener('paste', this.handlePaste);
      el.__ketPasteAttached = true;
    },
    detachPasteHandler() {
      const el = document.getElementById('editor');
      if (!el || !el.__ketPasteAttached) return;
      el.removeEventListener('paste', this.handlePaste);
      el.__ketPasteAttached = false;
    },
    selectImage() {
      this.$refs.imageInput.click();
    },
    selectWordDocument() {
      this.$refs.wordInput.click();
    },
    async insertImage(event) {
      const [file] = event.target.files;
      event.target.value = '';
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        this.$notify({
          message: 'Bitte wählen Sie eine Bilddatei aus.',
          icon: 'fa fa-exclamation-triangle',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger',
          showClose: true,
          timeout: 5000,
        });
        return;
      }

      try {
        const url = await this.uploadImage(file, file.type);
        const editorEl = document.getElementById('editor');
        if (!editorEl) return;
        editorEl.focus();
        this.insertHtmlIntoEditor(`<img src="${url}" alt="">`, true);
        this.editText = editorEl.innerHTML;
        this.unsaved = true;
      } catch (err) {
        console.log('Image upload failed', err);
        this.$notify({
          message: 'Das Bild konnte nicht hochgeladen werden.',
          icon: 'fa fa-exclamation-triangle',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger',
          showClose: true,
          timeout: 5000,
        });
      }
    },
    async importWordDocument(event) {
      const [file] = event.target.files;
      event.target.value = '';
      if (!file) return;
      const isDocx = file.name.toLowerCase().endsWith('.docx') || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      if (!isDocx) {
        this.$notify({
          message: 'Bitte wählen Sie ein Word-Dokument im .docx-Format aus.',
          icon: 'fa fa-exclamation-triangle',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger',
          showClose: true,
          timeout: 5000,
        });
        return;
      }

      try {
        const arrayBuffer = await this.readFileAsArrayBuffer(file);
        const result = await mammoth.convertToHtml({ arrayBuffer }, {
          convertImage: mammoth.images.inline((image) => image.read('base64').then((imageBuffer) => ({
            src: `data:${image.contentType};base64,${imageBuffer}`,
          }))),
        });
        this.insertHtmlIntoEditor(this.cleanWordHtml(result.value || ''), true);
        await this.uploadInlineImages();
        this.unsaved = true;
        this.$notify({
          message: 'Word-Dokument wurde erfolgreich importiert.',
          icon: 'fa fa-check-circle',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success',
          showClose: true,
          timeout: 5000,
        });
        if (result.messages && result.messages.length > 0) {
          console.log('Word import warnings', result.messages);
        }
      } catch (err) {
        console.log('Word import failed', err);
        this.$notify({
          message: 'Das Word-Dokument konnte nicht importiert werden.',
          icon: 'fa fa-exclamation-triangle',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger',
          showClose: true,
          timeout: 8000,
        });
      }
    },
    readFileAsArrayBuffer(file) {
      if (file.arrayBuffer) return file.arrayBuffer();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.readAsArrayBuffer(file);
      });
    },
    async uploadImage(file, mime) {
      const id = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const path = `buschtrommel/${this.location || 'unknown'}/${id}.${this.extensionFromMime(mime)}`;
      const imageRef = storageRef(storage, path);
      await uploadBytes(imageRef, file, { contentType: mime });
      return getDownloadURL(imageRef);
    },
    extensionFromMime(mime) {
      const extensions = {
        'image/png': 'png',
        'image/jpeg': 'jpg',
        'image/jpg': 'jpg',
        'image/gif': 'gif',
        'image/webp': 'webp',
        'image/svg+xml': 'svg',
        'image/bmp': 'bmp',
      };
      return extensions[mime.toLowerCase()] || 'bin';
    },
    insertHtmlIntoEditor(html, appendIfSelectionMissing = false) {
      const editorEl = document.getElementById('editor');
      if (!editorEl) return;
      editorEl.focus();
      const selection = window.getSelection();
      const range = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
      const selectedNode = range && range.commonAncestorContainer.nodeType === 1
        ? range.commonAncestorContainer
        : range && range.commonAncestorContainer.parentNode;
      if (appendIfSelectionMissing && (!selectedNode || !editorEl.contains(selectedNode))) {
        editorEl.insertAdjacentHTML('beforeend', html);
      } else {
        document.execCommand('insertHTML', false, html);
      }
      this.editText = editorEl.innerHTML;
    },
    handlePaste(event) {
      const cb = event.clipboardData || window.clipboardData;
      if (!cb) return;
      const html = cb.getData('text/html');
      const text = cb.getData('text/plain');
      event.preventDefault();
      let toInsert;
      if (html && html.trim().length > 0) {
        toInsert = this.cleanWordHtml(html);
      } else {
        toInsert = (text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r?\n/g, '<br>');
      }
      this.insertHtmlIntoEditor(toInsert);
      this.unsaved = true;
      // Asynchronously upload any inline base64 images to Firebase Storage and replace src
      this.uploadInlineImages();
    },
    async uploadInlineImages() {
      const editorEl = document.getElementById('editor');
      if (!editorEl) return;
      const imgs = Array.from(editorEl.querySelectorAll('img'))
        .filter((img) => /^data:image\//i.test(img.getAttribute('src') || ''));
      if (imgs.length === 0) return;

      const notify = (msg, type) => this.$notify({
        message: msg,
        icon: type === 'success' ? 'fa fa-check-circle' : 'fa fa-exclamation-triangle',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type,
        showClose: true,
        timeout: 5000,
      });

      notify(`${imgs.length} Bild(er) werden hochgeladen …`, 'info');

      const dataUrlToBlob = (dataUrl) => {
        const m = /^data:([^;,]+)(;base64)?,(.*)$/i.exec(dataUrl);
        if (!m) return null;
        const mime = m[1] || 'application/octet-stream';
        const isBase64 = !!m[2];
        const data = m[3] || '';
        let bytes;
        if (isBase64) {
          const bin = atob(data);
          bytes = new Uint8Array(bin.length);
          for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
        } else {
          const decoded = decodeURIComponent(data);
          bytes = new Uint8Array(decoded.length);
          for (let i = 0; i < decoded.length; i++) bytes[i] = decoded.charCodeAt(i);
        }
        return { blob: new Blob([bytes], { type: mime }), mime };
      };

      let success = 0;
      let failed = 0;
      for (const img of imgs) {
        const src = img.getAttribute('src') || '';
        const parsed = dataUrlToBlob(src);
        if (!parsed) { failed++; continue; }
        try {
          const url = await this.uploadImage(parsed.blob, parsed.mime);
          img.setAttribute('src', url);
          success++;
        } catch (err) {
          console.log('Image upload failed', err);
          failed++;
        }
      }

      // Sync v-model with the updated DOM
      this.editText = editorEl.innerHTML;

      if (success > 0) notify(`${success} Bild(er) erfolgreich hochgeladen.`, 'success');
      if (failed > 0) notify(`${failed} Bild(er) konnten nicht hochgeladen werden.`, 'danger');
    },
    cleanWordHtml(html) {
      // Strip everything outside the StartFragment/EndFragment markers if present
      const startMatch = html.match(/<!--StartFragment-->/i);
      const endMatch = html.match(/<!--EndFragment-->/i);
      if (startMatch && endMatch) {
        const start = startMatch.index + startMatch[0].length;
        const end = endMatch.index;
        if (end > start) html = html.substring(start, end);
      }
      // Remove conditional comments, XML islands, Word-specific tags
      html = html
        .replace(/<!--[\s\S]*?-->/g, '')
        .replace(/<\?xml[^>]*>/gi, '')
        .replace(/<\/?(?:o|w|m|v|st1|xml|meta|link|style|script|head|title)(?::[a-z0-9]+)?[^>]*>/gi, '');

      // Parse and walk the DOM to clean tags/attributes
      const allowedTags = new Set([
        'P', 'BR', 'SPAN', 'DIV',
        'H1', 'H2', 'H3', 'H4', 'H5', 'H6',
        'STRONG', 'B', 'EM', 'I', 'U',
        'UL', 'OL', 'LI',
        'A',
        'IMG',
        'TABLE', 'THEAD', 'TBODY', 'TFOOT', 'TR', 'TH', 'TD', 'CAPTION',
        'BLOCKQUOTE',
      ]);
      const allowedAttrs = {
        A: ['href', 'target', 'rel'],
        IMG: ['src', 'alt', 'title'],
        TD: ['colspan', 'rowspan'],
        TH: ['colspan', 'rowspan'],
      };
      const container = document.createElement('div');
      container.innerHTML = html;

      const walk = (node) => {
        const children = Array.from(node.childNodes);
        for (const child of children) {
          if (child.nodeType === 1) {
            const tag = child.tagName;
            if (!allowedTags.has(tag)) {
              // Replace disallowed element with its children
              while (child.firstChild) node.insertBefore(child.firstChild, child);
              node.removeChild(child);
              continue;
            }
            // Drop <img> with unsafe schemes (javascript:, file:, etc.). Keep http(s) and data: –
            // data: images get uploaded to Firebase Storage right after paste (see uploadInlineImages).
            if (tag === 'IMG') {
              const src = (child.getAttribute('src') || '').trim();
              if (!/^(https?:\/\/|data:image\/)/i.test(src)) {
                node.removeChild(child);
                continue;
              }
            }
            // Strip all attributes except allowed
            const allow = allowedAttrs[tag] || [];
            for (const attr of Array.from(child.attributes)) {
              if (!allow.includes(attr.name.toLowerCase())) {
                child.removeAttribute(attr.name);
              }
            }
            // Drop empty SPAN/DIV by unwrapping
            if ((tag === 'SPAN' || tag === 'DIV') && child.attributes.length === 0) {
              while (child.firstChild) node.insertBefore(child.firstChild, child);
              node.removeChild(child);
              continue;
            }
            walk(child);
          } else if (child.nodeType === 8) {
            // Comment node
            node.removeChild(child);
          }
        }
      };
      walk(container);

      // Collapse multiple whitespace and non-breaking-space artifacts
      let cleaned = container.innerHTML
        .replace(/\u00A0/g, ' ')
        .replace(/\s+\n/g, '\n')
        .replace(/<p>\s*<\/p>/gi, '')
        .replace(/<p>(\s|&nbsp;)*<br\s*\/?>(\s|&nbsp;)*<\/p>/gi, '<br>');
      return cleaned;
    },
    loadData() {
      moment.locale("de");
      const buschtrommelRef = db.collection("buschtrommel");
      buschtrommelRef.where('locationID', 'array-contains', this.location).orderBy("createdAt", "desc").onSnapshot((snapshotChange) => {
        this.buschtrommel = [];
        snapshotChange.forEach((doc) => {
          var title = ""
          if (doc.data().status == "Draft") {
            title = "ENTWURF - " + moment(new Date(doc.data().createdAt.seconds * 1000))
              .format("DD. MMMM yyyy")
              .toString()
          } else if (doc.data().status == "Published") {
            title = "Newsletter - " + moment(new Date(doc.data().publishedAt.seconds * 1000))
              .format("DD. MMMM yyyy")
              .toString()
          }
          if (doc.data().status == "Published" || (doc.data().status == "Draft" && this.role > 1)) {
            this.buschtrommel.push({
              key: doc.id,
              createdAt: doc.data().createdAt,
              publishedAt: doc.data().publishedAt,
              title: title,
              text: doc.data().text,
              status: doc.data().status,
              email: doc.data().sendMail,
            });
          }

        });
        this.loading = false
      });
    },
    saveDraft() {
      const notifySuccess = () => {
        this.unsaved = false;
        this.$notify({
          message: 'Entwurf wurde erfolgreich gespeichert!',
          icon: 'fa fa-check-circle',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success',
          showClose: true,
          timeout: 5000
        });
      };
      const notifyError = (err) => {
        const tooLarge = err && (err.code === 'invalid-argument' || /longer than\s+1048487\s+bytes/i.test(err.message || ''));
        this.$notify({
          message: tooLarge
            ? 'Der Inhalt ist zu groß zum Speichern (max. 1 MB pro Newsletter). Bitte eingebettete Bilder entfernen oder als Link einfügen und es erneut versuchen.'
            : 'Speichern des Entwurfs fehlgeschlagen.',
          icon: 'fa fa-exclamation-triangle',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger',
          showClose: true,
          timeout: 8000
        });
        console.log('Saving draft failed', err);
      };
      if (this.editId != null) {
        db.collection("buschtrommel").doc(this.editId)
          .update({
            text: this.editText,
            status: 'Draft',
          })
          .then(() => {
            notifySuccess();
          })
          .catch(notifyError);
      } else {
        db.collection("buschtrommel")
          .add({
            text: this.editText,
            status: 'Draft',
            createdAt: new Date(),
            locationID: [this.location]
          })
          .then((docRef) => {
            this.editId = docRef.id;
            notifySuccess();
          })
          .catch(notifyError);
      }
    },
    publish() {
      if (this.editId != null) {
        db.collection("buschtrommel").doc(this.editId)
          .update({
            text: this.editText,
            publishedAt: new Date(),
            status: 'Published',
            sendMail: this.sendMail
          })
          .then(() => {
            if (this.sendMail == true) {
              console.log("Send mail")
              var sendBuschtrommel = httpsCallable(fc, "buschtrommel-sendMail");
              sendBuschtrommel({
                buschtrommelId: this.editId,
                loc: this.location
              })
            }
            this.unsaved = false;
            this.editId = null;
            this.editMode = false;
            this.$notify({
              message: 'Newsletter wurde erfolgreich veröffentlicht!',
              icon: 'fa fa-check-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success',
              showClose: true,
              timeout: 5000
            })
          })
          .catch((err) => {
            console.log("Publishing failed " + err);
          });
      } else {
        db.collection("buschtrommel")
          .add({
            text: this.editText,
            status: 'Published',
            createdAt: new Date(),
            publishedAt: new Date(),
            locationID: [this.location],
            sendMail: this.sendMail
          })
          .then((docRef) => {
            if (this.sendMail == true) {
              var sendBuschtrommel = httpsCallable(fc, "buschtrommel-sendMail");
              sendBuschtrommel({
                buschtrommelId: docRef.id,
                loc: this.location
              })
            }
            this.unsaved = false;
            this.editId = null;
            this.editMode = false;
            this.$notify({
              message: 'Newsletter wurde erfolgreich veröffentlicht!',
              icon: 'fa fa-check-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success',
              showClose: true,
              timeout: 5000
            })
          })
          .catch(() => {
            console.log("Publishing failed");
          });
      }

    },
    edit(id, text) {
      // Clean stored content (older drafts may still contain Word bloat / base64 images)
      const cleaned = this.cleanWordHtml(text || '');
      this.editText = cleaned;
      this.editId = id;
      this.editMode = true;
      this.unsaved = cleaned !== text; // mark dirty only if cleaning changed something
      this.scrollToEditSection();
    },
    scrollToEditSection() {
      this.$nextTick(() => {
        if (this.$refs.editSection) {
          this.$refs.editSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    newBuschtrommel() {
      this.editId = null;
      this.editText = null;
      this.editMode = true;
      this.unsaved = true;
    },
    preventNav(event) {
      if (!this.unsaved) return
      event.preventDefault()
      event.returnValue = ""
    },
    updateLocation(loc) {
      this.location = loc
      this.loadData()
    }
  },
};
</script>
<style>
.el-table .cell {
  word-break: break-word !important;
}

.wysiwyg-button {
  border: none !important;
}

#editor table,
.buschtrommel-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 0.75rem 0;
}

#editor th,
#editor td,
.buschtrommel-content th,
.buschtrommel-content td {
  border: 1px solid #d8d8d8;
  padding: 0.35rem 0.5rem;
  vertical-align: top;
}

#editor img,
.buschtrommel-content img {
  max-width: 100%;
  height: auto;
}
</style>
